import { loadable } from '../../../common/utils/lazyLoading';
import styles from './menu.scss';
const Notifications = loadable(() => import('../Notifications'));
const Messages = loadable(() => import('../Messages'));
const Conversations = loadable(() => import('../Conversations'));
const Emails = loadable(() => import('../Emails'));
const News = loadable(() => import('../News'));
const Individuals = loadable(() => import('../Contacts/Individuals'));
export default ({ isStaff, accessList }) => {
    const pages = [
        {
            id: 'notifications',
            permission: 'notifications',
            title: 'Notifications',
            route: 'notifications',
            component: Notifications,
            icon: 'bell2',
        },
        {
            id: 'messages',
            permission: 'messages',
            title: 'Messages',
            route: 'messages',
            component: Messages,
            icon: 'bubbles',
        },
        {
            id: 'conversations',
            permission: 'conversations',
            title: 'Conversations',
            route: 'conversations',
            component: Conversations,
            icon: 'bubbles5',
        },
        {
            id: 'emails',
            permission: 'emails',
            title: 'Emails',
            route: 'emails',
            component: Emails,
            icon: 'envelop3',
        },
    ];
    if (isStaff || accessList.includes('administration.ed_com.news')) {
        pages.push({
            id: 'news',
            permission: 'news',
            title: 'News',
            route: 'news',
            component: News,
            icon: 'newspaper',
        });
    }
    pages.push({
        id: 'contacts',
        permission: 'contacts',
        title: 'Contacts',
        route: 'contacts',
        children: [
            {
                permission: 'contacts.individuals',
                route: 'individuals',
                title: 'Individuals',
                component: Individuals,
            },
        ],
        icon: 'users4',
        iconClassName: styles.mr13,
    });
    return pages;
};
